import { render, staticRenderFns } from "./StoreProvider.vue?vue&type=template&id=5e9b579a&scoped=true"
import script from "./StoreProvider.vue?vue&type=script&lang=js"
export * from "./StoreProvider.vue?vue&type=script&lang=js"
import style0 from "./StoreProvider.vue?vue&type=style&index=0&id=5e9b579a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e9b579a",
  null
  
)

export default component.exports